<script setup lang="ts">
import { loaded } from '~/composables/useAccessEventHandler'
</script>

<template>
  <v-footer
    v-if="loaded"
    class="footer mb-4"
  >
    <v-row>
      <v-col class="flex-column flex-md-row">
        <div>
          {{ `© ${(new Date()).getFullYear()} Traveler Cashback. All rights reserved.` }}
        </div>
        <a
          class="privacy-policy-link"
          href="https://oliveltd.com/legal/website-privacy"
          target="_blank"
        >Privacy Policy
        </a>
      </v-col>
    </v-row>
  </v-footer>
</template>

<style lang="scss" scoped>
.footer {
  color: rgb(0 0 0 / 56%);
}

.v-col {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  flex-wrap: nowrap;
}

@media screen and (max-width: 767px) {
  .footer {
    font-size: 14px;
  }
}

.privacy-policy-link {
  color: rgb(var(--v-theme-primary));
  cursor: pointer;
  font-weight: 800;
  margin-left: 6px;
  text-decoration: underline;
}

.privacy-policy-link a:hover {
  color: rgb(var(--v-theme-primary_dark));
}
</style>
